import PropTypes from "prop-types";
import Select, { components } from "react-select";
import styles from "./FilterSelector.module.styl";
import { ArrowDown } from "uikit/assets/icons";

export default function FilterSelector({
    name,
    header,
    options,
    selectedValue,
    onValueChanged,
    placeHolder,
    value,
    isDisabled,
    reference,
    ...props
}) {
    const selectorStyles = {
        control: (provided, state) => ({
            ...provided,
            borderWidth: "1px 1px 1px 0px",
            boxShadow: "none",
            borderRadius: "0px",
            borderColor: styles.borderColor,
            "&:hover": {
                borderColor: styles.borderHoverColor,
            },
            ...(state.isFocused && {
                borderColor: styles.borderFocusColor,
            }),
        }),
        option: (provided, state) => ({
            ...provided,
            opacity: state.isDisabled ? 0.7 : 1,
            color: "#000000",
            backgroundColor: "#FFFFFF",
            ...(!state.isDisabled && {
                "&:hover": {
                    backgroundColor: "#DFE1E6",
                    color: "#000000",
                },
            }),
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            transform: "translateY(-15%)",
            ...(state.selectProps.menuIsOpen && {
                transform: "translateY(-15%) rotate(180deg)",
            }),
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: "0",
            margin: "0px 0px 0px 8px",
        }),
        singleValue: (provided) => ({
            ...provided,
            margin: "0",
            color: "#394E76",
            fontSize: "14px",
            fontWeight: "500",
            lineHeight: "18px",
        }),
        input: (provided) => ({
            ...provided,
            margin: "0",
            padding: "0",
        }),
    };

    // eslint-disable-next-line react/no-unstable-nested-components
    const Control = (props) => {
        return (
            <components.Control {...props}>
                <div className={styles.control}>
                    <div className={styles.header}>{header}</div>
                    <components.ValueContainer {...props} />
                </div>
            </components.Control>
        );
    };

    // eslint-disable-next-line react/no-unstable-nested-components
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <div className={styles.dropdownIcon}>
                    <ArrowDown />
                </div>
            </components.DropdownIndicator>
        );
    };

    return (
        <Select
            {...props}
            name={name}
            styles={selectorStyles}
            components={{
                Control,
                DropdownIndicator,
                IndicatorSeparator: null,
            }}
            onChange={(newSelectedOption) => {
                const value = newSelectedOption.value;
                if (onValueChanged) onValueChanged(value);
            }}
            value={value ?? null}
            options={options}
            placeholder={placeHolder}
            isDisabled={isDisabled}
            ref={reference}
            maxMenuHeight={430}
            noOptionsMessage={() => "Нет вариантов для выбора"}
        />
    );
}

export const FilterOptionProps = PropTypes.shape({
    value: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
});

const FilterSelectorProps = {
    name: PropTypes.string,
    header: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(FilterOptionProps).isRequired,
    selectedValue: PropTypes.object,
    onValueChanged: PropTypes.func.isRequired,
    value: PropTypes.object,
    placeHolder: PropTypes.string,
    reference: PropTypes.object,
    isDisabled: PropTypes.bool,
};

FilterSelector.propTypes = FilterSelectorProps;
